import React from "react";
import PropTypes from "prop-types";
import { Checkbox, Field, Hint, Label } from "@zendeskgarden/react-forms";


const ForPopulationField = ({ checked, onChange }) => {
  return (
    <Field>
      <Checkbox checked={checked} onChange={onChange}>
        <Label>Per 1.000.000 population</Label>
        <Hint>Scale chart to unify population</Hint>
      </Checkbox>
    </Field>
  );
};

ForPopulationField.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ForPopulationField;
